module.exports = __webpack_public_path__ + "img/ios_black.38307224.svg";